<template>
    <div class="popup">
        <div class="popup-content">
            <img src="/img/close-btn.svg" class="modal__close" @click="closePopup" />
            <div class="popup-text">
                <div class="popup-title">
                    <i18n-t keypath="dashboard.manualTransferInfo.title" />
                </div>
                <div class="popup-subtitle">
                    <i18n-t
                        keypath="dashboard.manualTransferInfo.manualTransferDescription"
                    />
                </div>
                <div class="popup-information">
                    <div class="info">
                        <div class="title-name">
                            <strong>
                                <i18n-t
                                    keypath="dashboard.manualTransferInfo.transferTo"
                                />
                            </strong>
                        </div>
                        <div class="value">
                            <span>Carconnex NV</span>
                        </div>
                    </div>
                    <div class="info">
                        <div class="title-name">
                            <strong>
                                <i18n-t keypath="dashboard.manualTransferInfo.address" />
                            </strong>
                        </div>
                        <div class="value">
                            <span>Grijpenlaan 19, 3300 Tienen, Belgium</span>
                        </div>
                    </div>
                    <div class="info">
                        <div class="title-name">
                            <strong>
                                <i18n-t
                                    keypath="dashboard.manualTransferInfo.bankAccount"
                                />
                            </strong>
                        </div>
                        <div class="value">
                            <span>IBAN BE88 0014 0617 4341</span>
                        </div>
                    </div>
                    <div class="info">
                        <div class="title-name">
                            <strong>SWIFT:</strong>
                        </div>
                        <div class="value">
                            <span>GEBABEBB08A</span>
                        </div>
                    </div>
                </div>
                <div class="popup-info" v-if="!!paymentDto?.length">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <i18n-t
                                        keypath="dashboard.manualTransferInfo.reference"
                                    />
                                </th>
                                <th>
                                    <i18n-t
                                        keypath="dashboard.manualTransferInfo.totalAmount"
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in paymentDto" :key="payment.id">
                                <td>{{ payment.reference }}</td>
                                <td>
                                    <app-format-currency
                                        :value="payment.total_amount_euro"
                                        currency="EUR"
                                    ></app-format-currency>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="button-container">
                <button class="button-text ok-button" @click="closePopup">OK</button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.popup-content {
    position: relative;
    width: 500px;
    max-height: 90vh;
    padding: 20px;
    padding-bottom: 0; /* Убираем паддинг снизу */
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    box-sizing: border-box;
    overflow: auto;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
}

.popup-text {
    text-align: center;
}

.popup-title {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    margin-top: 10px;
    color: rgba(40, 55, 71, 1);
}

.popup-subtitle {
    margin-top: 30px;
    margin-bottom: 30px;
}

.popup-information {
    background-color: rgba(228, 234, 240, 1);
    padding: 15px;
    border-radius: 4px;
    flex-shrink: 0;
    width: 459px;
    height: 107px;
    margin-top: 30px;
}

.title-name {
    font-size: 13px;
    font-weight: 600;
    line-height: 19.5px;
    text-align: left;
    color: rgba(98, 118, 144, 1);
}

.value {
    margin-left: 20px;
    font-size: 13px;
    font-weight: 400;
    line-height: 19.5px;
    text-align: left;
    color: rgba(98, 118, 144, 1);
}
.info {
    display: flex;
    align-items: center;
}

.info strong {
    min-width: 150px;
    text-align: left;
}

.info span {
    text-align: left;
}

.popup-info {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    color: rgba(40, 55, 71, 1);
    margin-top: 20px;
    flex-grow: 1;
    overflow: auto;
}

.popup-info table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.popup-info th,
.popup-info td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid rgba(228, 234, 240, 1);
}

.popup-info th {
    font-size: 13px;
    font-weight: 600;
    line-height: 19.5px;
    text-align: left; /* Изменено на left */
    color: rgba(40, 55, 71, 1);
}

.status {
    color: rgba(249, 198, 17, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0.02em;
    text-align: center;
    border: 1px solid rgba(249, 198, 17, 1);
    width: 62px;
    height: 23px;
    display: inline-block;
    border-radius: 4px;
    padding: 4px 0;
}

.button-container {
    width: calc(100% + 40px);
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding: 30px 20px;
}

.button-container button {
    width: 119px;
    height: 40px;
    top: 497px;
    left: 370px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid rgba(26, 160, 225, 1);
}

.ok-button {
    color: white;
    background: rgba(26, 160, 225, 1);
}

.ok-button:hover {
    transform: scale(1.05);
}
</style>
<script lang="ts">
import { ManualTransferPopup } from "@/dashboard/my-orders/new-popup/manual-transfer-popup/manual-transfer-popup";

export default ManualTransferPopup;
</script>
